import { jsx as _jsx } from "react/jsx-runtime";
import Modal from "../../../../components/atoms/Modal/index.js";
import Box from "../../../../components/atoms/Box/index.js";
export const MobileSearchModalComponent = ({ open, onClose, children, }) => (_jsx(Modal, { open: open, onClose: onClose, sx: { zIndex: 1000000 }, keepMounted: true, disablePortal: true, children: _jsx(Box, { sx: { paddingX: 3, paddingTop: 3 }, children: children }) }));
export default MobileSearchModalComponent;
